/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SharedMobileMoreWaysToBrowse_internalBuyLinks$ref = any;
type SharedRespMoreWaysToBrowse_internalBuyLinks$ref = any;
export type BuySharedMoreWaysToBrowse_internalBuyLinks$ref = any;
export type BuySharedMoreWaysToBrowse_internalBuyLinks = ReadonlyArray<{
    readonly " $fragmentRefs": SharedRespMoreWaysToBrowse_internalBuyLinks$ref & SharedMobileMoreWaysToBrowse_internalBuyLinks$ref;
    readonly " $refType": BuySharedMoreWaysToBrowse_internalBuyLinks$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "BuySharedMoreWaysToBrowse_internalBuyLinks",
    "type": "InternalBuyLinkType",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SharedRespMoreWaysToBrowse_internalBuyLinks",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "SharedMobileMoreWaysToBrowse_internalBuyLinks",
            "args": null
        }
    ]
} as any);
(node as any).hash = '2509a5d91605340d03e6f6f7faa4c103';
export default node;
